import React from "react";
import "./MapStyle.css";

const ProgramCardSkeleton = () => {
  // Create an array of 3 skeleton items
  const skeletonItems = Array(25).fill(0);

  return (
    <div className="d-flex flex-wrap gap20">
      {skeletonItems.map((_, index) => (
        <div
          key={index}
          className="programCard d-flex w100 bg-white radius5 gap20 p-2"
          style={{ opacity: 0.7 }}
        >
          {/* Image skeleton */}
          <div
            className="radius5 w40 skeleton-pulse"
            style={{
              backgroundColor: "#e0e0e0",
              minHeight: "180px",
            }}
          />

          <div className="w100 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column gap10">
                  {/* Program name skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "24px",
                      width: "180px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                    }}
                  />

                  {/* Promoteur name skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "18px",
                      width: "140px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                    }}
                  />

                  {/* Address skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "18px",
                      width: "160px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                    }}
                  />
                </div>

                <div className="d-flex flex-column text-end">
                  {/* TVA skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "14px",
                      width: "80px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      marginLeft: "auto",
                    }}
                  />

                  {/* Price skeleton */}
                  <div className="mb-10">
                    <div
                      className="skeleton-pulse"
                      style={{
                        height: "14px",
                        width: "60px",
                        backgroundColor: "#e0e0e0",
                        borderRadius: "4px",
                        marginLeft: "auto",
                        marginBottom: "5px",
                      }}
                    />
                    <div
                      className="skeleton-pulse"
                      style={{
                        height: "20px",
                        width: "100px",
                        backgroundColor: "#e0e0e0",
                        borderRadius: "4px",
                        marginLeft: "auto",
                      }}
                    />
                  </div>

                  {/* Honoraires skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "14px",
                      width: "70px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      marginLeft: "auto",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="separator my-2"></div>

            <div className="d-flex justify-content-between">
              <div className="d-flex gap10 flex-wrap align-items-center">
                {/* Favorite icon skeleton */}
                <div
                  className="skeleton-pulse"
                  style={{
                    height: "35px",
                    width: "35px",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "50%",
                  }}
                />
              </div>

              <div className="d-flex gap-3">
                <div>
                  {/* Actabilité label skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "14px",
                      width: "70px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      marginBottom: "5px",
                    }}
                  />

                  {/* Actabilité value skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "18px",
                      width: "80px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      marginBottom: "20px",
                    }}
                  />
                </div>

                <div>
                  {/* Livraison label skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "14px",
                      width: "70px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      marginBottom: "5px",
                    }}
                  />

                  {/* Livraison value skeleton */}
                  <div
                    className="skeleton-pulse"
                    style={{
                      height: "18px",
                      width: "80px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgramCardSkeleton;
